export default "__VITE_ASSET__BKSibTu9__"